import { Hero } from "@/components/home/Hero";
import { LinkHub } from "@/components/home/LinkHub";
import { Collections } from "@/components/home/Collections";
import { Bento } from "@/components/home/Bento";
import { TissueTeaser, SouvenirTeaser } from "@/components/home/Teasers";
import { Marquee } from "@/components/motion";
import { useLang } from "@/context/LangContext";

const NAMES = ["Philodendron", "Anthurium", "Alocasia", "Aglaonema", "Begonia", "Syngonium", "Scindapsus", "Monstera", "Cyrtosperma", "Homalomena", "Hoya"];

export default function Home() {
  const { t } = useLang();
  return (
    <>
      <Hero />
      <div className="border-y border-leaf/15 bg-white py-6 sm:py-8">
        <Marquee testid="home-marquee" items={[...NAMES, t("Bunga Hias", "Flowering Plants")]} className="font-display text-4xl sm:text-6xl font-black tracking-tight text-[var(--leaf)]" />
      </div>
      <LinkHub />
      <Collections />
      <Bento />
      <TissueTeaser />
      <SouvenirTeaser />
    </>
  );
}
